"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var DatePicker_1 = require("@mui/x-date-pickers/DatePicker");
var LocalizationProvider_1 = require("@mui/x-date-pickers/LocalizationProvider");
var AdapterMoment_1 = require("@mui/x-date-pickers/AdapterMoment");
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var react_1 = __importDefault(require("react"));
var Warning_1 = __importDefault(require("@mui/icons-material/Warning"));
/**
 *
 * date picker that is compatible with safari and firefox.
 * pass in initial values of new Date() to avoid keyboard input issues.
 *
 * @component DatePicker
 *
 * @example
 * return (
 * <DatePicker
 *    error={someBool}
 *    label="Recurring Payment Date"
 *    minDate={getDateInFuture(1)}
 *    maxDate={getDateInFuture(60)}
 *    daysToDisable={[29, 30, 31]}
 *    value={formik.values.paymentDay}
 *    onChange={(date: Date) => {
 *      formik.setFieldValue("paymentDay", date.toISOString());
 *    }}
 *  />
 * )
 *
 * @param {Date} value value of the picker
 * @param {function} onChange function for what happens on change
 * @param {string} label label of the timepicker
 * @param {boolean} disabled is the time picker disabled
 * @param {Date} minDate date limiter, min value
 * @param {Date} maxDate date limiter, maximum value
 * @param {string | boolean} error whether there is an error (boolean) or error message
 * @param {string} className pass classnames to the date picker
 * @param {number[]} daysToDisable enter an array, the days of the month to disable. example: [1, 30, 31]
 */
var DatePicker = function (props) {
    var value = props.value, onChange = props.onChange, label = props.label, disabled = props.disabled, minDate = props.minDate, maxDate = props.maxDate, error = props.error, className = props.className, daysToDisable = props.daysToDisable, data = props.data, _a = props.desktopModeMediaQuery, desktopModeMediaQuery = _a === void 0 ? '@media (min-width: 720px)' : _a, _b = props.fullWidth, fullWidth = _b === void 0 ? false : _b;
    function disableDays(date) {
        if (!daysToDisable)
            return false;
        return daysToDisable.some(function (dayOfMonth) {
            return new Date(date).getDate() === dayOfMonth;
        });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(LocalizationProvider_1.LocalizationProvider, { dateAdapter: AdapterMoment_1.AdapterMoment },
            react_1.default.createElement(DatePicker_1.DatePicker, { className: className, mask: "__/__/____", label: label, value: value, minDate: minDate, maxDate: maxDate, onChange: onChange, disabled: disabled, shouldDisableDate: disableDays, desktopModeMediaQuery: desktopModeMediaQuery, renderInput: function (params) { return react_1.default.createElement(TextField_1.default, __assign({}, params, { fullWidth: fullWidth, "data-test": data })); } }),
            error && (react_1.default.createElement(material_1.Grid, { container: true, className: "error-message" },
                react_1.default.createElement(material_1.Grid, { item: true },
                    react_1.default.createElement(Warning_1.default, null)),
                react_1.default.createElement(material_1.Grid, { item: true }, error))))));
};
exports.default = DatePicker;
